import { modules } from "../../components/modules";

export const flowDisabledLoan = {
  name: "loan disabled",
  modules: [
    {
      id: modules.DISABLED.id,
      section: {
        name: null,
      },
    },
  ],
};
